/* global ApeConfig */
import React from 'react';
import axios from 'axios';
import { Typography, Input, Button, Flex, Radio } from 'antd';
import { useWeb3ModalProvider, useWeb3ModalAccount } from '@web3modal/ethers/react'
import { usePermissions } from './context/PermissionsContext';
import { BrowserProvider, Contract } from 'ethers'
import { SmortContract } from './shared/ApeStoreContract';

const { Text } = Typography;
const { TextArea } = Input;

export const Auth = () => {
	const { isAdmin, isAuthenticated } = usePermissions();
	const [addressString, setAddressString] = React.useState("");
	const [router, setRouter] = React.useState(0);
	const { walletProvider } = useWeb3ModalProvider();
	const [canSubmit, setCanSubmit] = React.useState(true)
	const { address, chainId, isConnected } = useWeb3ModalAccount();

	const handleChainChange = async (chain) => {
		if (chain !== 0) {
			const provider = new BrowserProvider(walletProvider);
			const chainId = '0x' + (chain).toString(16);
			await provider.send('wallet_switchEthereumChain', [{ chainId }]);
		}
	}

	const config = ApeConfig.find(x => x.Short === 8453 || x.ID == 8453);

	const handleClaim = async () => {
		setCanSubmit(false);
		try {
			const ethersProvider = new BrowserProvider(walletProvider);
			const signer = await ethersProvider.getSigner();
			const apeStore = new Contract("0x533c68360bE3e0caC63d70ccd5768AcCe2495818", SmortContract, signer);
			await apeStore.collectFees(config.ApeV30Routers[router], addressString.split("\n"));
		}
		finally {
			setCanSubmit(true);
		}
	}

	React.useEffect(() => {
		setAddressString("");
		axios.get(`/api/admin/recent?router=${router}`).then(response => {
			setAddressString(response.data.join("\n"));
		});
	}, [router]);

	if (!isAuthenticated || !isAdmin) {
		return;
	}

	return (
		<Flex vertical>
			<Radio.Group value={chainId} onChange={(e) => { setRouter(e.target.value); }}>
				{config.ApeV30Routers.map((x, i) => {

					return (
						<Radio.Button key={x} value={i} >
							<Flex align="center" gap={5}>
								<Text>{`Router ${i}`}</Text>
							</Flex>
						</Radio.Button>
					);
				})}
			</Radio.Group>
			<div style={{ marginTop: '40px' }} >V3 Tokens active last hour</div>
			<TextArea rows={20} value={addressString} onChange={(v) => setAddressString(v.target.value) }></TextArea>		
			<Button onClick={handleClaim} disabled={!canSubmit}>Claim All</Button>
		</Flex>
	);
};
